import { publisherWorkflowsT } from 'services/workflows/publisher_workflows_i18n'

import {
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_INVITEE_NO_SHOW,
  BOOKING_BEFORE_MEETING_STARTED,
  BOOKING_WHEN_MEETING_CANCELED,
  BOOKING_WHEN_MEETING_FINISHED,
  BOOKING_WHEN_MEETING_RESCHEDULED,
  BOOKING_WHEN_MEETING_SCHEDULED,
  BOOKING_WHEN_MEETING_STARTED,
  DEFAULT_TIME,
  DEFAULT_UNITS,
  UNITS_DAYS,
  UNITS_HOURS,
  UNITS_MINUTES,
} from './modals/controls/trigger_edit/consts'

const pt = (key, isRebrand, params) => publisherWorkflowsT(key, isRebrand, params)

/** Invitee-booked shape shared by booking.when.invitee_booked and booking.when.meeting_scheduled */
const buildInviteeBookedI18n = () => ({
  when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.when_this_happens', isRebrand),
  how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.how_long', isRebrand),
  immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.immediately', isRebrand),
  timing: {
    [UNITS_DAYS]: (params, isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.timing.days', isRebrand, params),
    [UNITS_HOURS]: (params, isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.timing.hours', isRebrand, params),
    [UNITS_MINUTES]: (params, isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_booked.timing.minutes', isRebrand, params)
  }
})

/**
 * Static trigger copy map. Each function takes `isRebrand` at call time so a live feature-flag
 * change cannot leave stale `publisherWorkflowsT` branding cached for the rest of the session.
 */
const TRIGGER_I18N_MAP = Object.freeze({
  [BOOKING_WHEN_INVITEE_BOOKED]: buildInviteeBookedI18n(),
  [BOOKING_WHEN_MEETING_SCHEDULED]: buildInviteeBookedI18n(),
  [BOOKING_BEFORE_MEETING_STARTED]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.before.meeting_started.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.before.meeting_started.how_long', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.before.meeting_started.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.before.meeting_started.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.before.meeting_started.timing.minutes',
        isRebrand,
        params
      )
    }
  },
  [BOOKING_WHEN_MEETING_STARTED]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_started.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_started.how_long', isRebrand),
    immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_started.immediately', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_started.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_started.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_started.timing.minutes',
        isRebrand,
        params
      )
    }
  },
  [BOOKING_WHEN_MEETING_FINISHED]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_finished.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_finished.how_long', isRebrand),
    immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_finished.immediately', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_finished.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_finished.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_finished.timing.minutes',
        isRebrand,
        params
      )
    }
  },
  [BOOKING_WHEN_MEETING_CANCELED]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_canceled.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_canceled.how_long', isRebrand),
    immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_canceled.immediately', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_canceled.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_canceled.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_canceled.timing.minutes',
        isRebrand,
        params
      )
    }
  },
  [BOOKING_WHEN_MEETING_RESCHEDULED]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_rescheduled.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_rescheduled.how_long', isRebrand),
    immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.meeting_rescheduled.immediately', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.minutes',
        isRebrand,
        params
      )
    }
  },
  [BOOKING_WHEN_INVITEE_NO_SHOW]: {
    when_this_happens: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_no_show.when_this_happens', isRebrand),
    how_long: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_no_show.how_long', isRebrand),
    immediately: (isRebrand) => pt('publisher.workflows.triggers.booking.when.invitee_no_show.immediately', isRebrand),
    timing: {
      [UNITS_DAYS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.invitee_no_show.timing.days',
        isRebrand,
        params
      ),
      [UNITS_HOURS]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.invitee_no_show.timing.hours',
        isRebrand,
        params
      ),
      [UNITS_MINUTES]: (params, isRebrand) => pt(
        'publisher.workflows.triggers.booking.when.invitee_no_show.timing.minutes',
        isRebrand,
        params
      )
    }
  }
})

export const whenThisHappensText = (type, isRebrand = false) => TRIGGER_I18N_MAP[type].when_this_happens(isRebrand)

export const howLongText = (type, isRebrand = false) => TRIGGER_I18N_MAP[type].how_long(isRebrand)

const triggerTitleWithTimingText = (type, isRebrand, { timeValue, timeUnits }) => {
  const i18nParams = { count: timeValue }
  const timeUnitI18nFunc = TRIGGER_I18N_MAP[type].timing[timeUnits]
  return timeUnitI18nFunc(i18nParams, isRebrand)
}

export const triggerTitleText = (workflowType, rule, isRebrand = false) => {
  const triggerType = rule.triggerType || rule.trigger_type
  const eventName = rule.eventName || rule.event_name
  const timeValue = rule.timeValue || rule.time_value
  const timeUnits = rule.timeUnits || rule.time_units

  const type = `${workflowType}.${triggerType}.${eventName}`
  const entry = TRIGGER_I18N_MAP[type]

  if (timeValue === null || timeValue === 0 || timeValue === undefined) {
    if (typeof entry.immediately === 'function') {
      return entry.immediately(isRebrand)
    }
    // e.g. booking.before.meeting_started — no "immediately" copy; use timing with safe defaults
    if (entry.timing) {
      const resolvedValue = timeValue === 0 ? 0 : (timeValue ?? DEFAULT_TIME)
      const resolvedUnits = timeUnits ?? DEFAULT_UNITS
      return triggerTitleWithTimingText(type, isRebrand, {
        timeValue: resolvedValue,
        timeUnits: resolvedUnits,
      })
    }
  }

  return triggerTitleWithTimingText(type, isRebrand, { timeValue, timeUnits })
}
